module.exports = __webpack_public_path__ + "img/d25beb7.jpg";